<template>
  <enb-seo-card comp="SeoLogin" label="Login"/>
</template>

<script>
import EnbSeoCard from './EnbSeoCard'
export default {
  name: 'EnbSeoLogin',
  components: { EnbSeoCard }
}
</script>
